<ada-card
	#UserPortalPropertiesCard
	id="UserPortalPropertiesCard"
	width="100%"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
>
	<ada-text
		content="User Portal Properties"
		data-container-selector="ada-card-header"
		id="UserPortalPropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<!-- Name -->
		<ng-container *ngIf="'Name' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				content="Name"
				[inheriting]="(currentPropertyObject?.Name | inheritPipe: inheritedPropertyObject?.Name) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'Name' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('Name')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#NameInput
					id="NameInput"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[maxCharacterLimit]="255"
					[placeholder]="'Name'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.Name"
					(valueChange)="setObjectPropertyValue('Name', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Description -->
		<ng-container *ngIf="'Description' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				content="Description"
				[inheriting]="(currentPropertyObject?.Description | inheritPipe: inheritedPropertyObject?.Description) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'Description' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('Description')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#DescriptionInput
					id="DescriptionInput"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[maxCharacterLimit]="8000"
					[placeholder]="'Description'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.Description"
					(valueChange)="setObjectPropertyValue('Description', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Version -->
		<ng-container *ngIf="'Version' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				content="Version"
				[inheriting]="(currentPropertyObject?.Version | inheritPipe: inheritedPropertyObject?.Version) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'Version' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('Version')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#VersionInput
					id="VersionInput"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[maxCharacterLimit]="255"
					[placeholder]="'Version'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.Version"
					(valueChange)="setObjectPropertyValue('Version', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- VendorName -->
		<ng-container *ngIf="'VendorName' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				content="Vendor Name"
				[inheriting]="(currentPropertyObject?.VendorName | inheritPipe: inheritedPropertyObject?.VendorName) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[isRequired]="'VendorName' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('VendorName')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#VendorNameInput
					id="VendorNameInput"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[maxCharacterLimit]="255"
					[placeholder]="'Publisher Name'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.VendorName"
					(valueChange)="setObjectPropertyValue('VendorName', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- TODO: Figure out what category means -->
		<!-- Categories -->
		<ng-container *ngIf="'Categories' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				content="Categories"
				[inheriting]="(currentPropertyObject?.Categories | inheritPipe: inheritedPropertyObject?.Categories) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('Categories')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-list-builder
					id="CategoriesInput"
					itemName="Category"
					[isDisabled]="isDisabled"
					[preventDuplicates]="true"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[value]="!(currentPropertyObject?.Categories | inheritPipe) ? currentPropertyObject?.Categories : inheritedPropertyObject?.Categories"
					(valueChange)="setObjectPropertyValue('Categories', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- Keywords -->
		<ng-container *ngIf="'Keywords' | displayAuthoringProperty: editorClass : propertyConstructor.namespace : forCustomization">
			<ada-authoring-property-label
				content="Keywords"
				[inheriting]="(currentPropertyObject?.Keywords | inheritPipe: inheritedPropertyObject?.Keywords) || isInheritanceDisabled"
				[isDisabled]="isDisabled"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('Keywords')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-list-builder
					id="KeywordsInput"
					itemName="Keyword"
					[isDisabled]="isDisabled"
					[preventDuplicates]="true"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[value]="!(currentPropertyObject?.Keywords | inheritPipe) ? currentPropertyObject?.Keywords : inheritedPropertyObject?.Keywords"
					(valueChange)="setObjectPropertyValue('Keywords', $event)"
				/>
			</ada-container>
		</ng-container>
	</ada-container>
</ada-card>
